import React, { JSX } from 'react';
import { startOfMonth, setDate } from 'date-fns';

import Flex from '../Flex';

import { getDayOfWeek, isCurrentDayOfWeek, isWeekend } from '../shared/dates';
import {
	formatShortWeekday as defaultFormatShortWeekday,
	formatWeekday as defaultFormatWeekday,
} from '../shared/dateFormatter';
import { cn } from '@fshr/shared-react';

type WeekdaysProps = {
	formatShortWeekday?: typeof defaultFormatShortWeekday;
	formatWeekday?: typeof defaultFormatWeekday;
	locale: string;
	style?: React.ComponentProps<'div'>['style'];
};

export default function Weekdays(props: WeekdaysProps) {
	const {
		formatShortWeekday = defaultFormatShortWeekday,
		formatWeekday = defaultFormatWeekday,
		locale,
		style,
	} = props;

	const anyDate = new Date();
	const beginOfMonth = startOfMonth(anyDate);
	const weekdays: JSX.Element[] = [];

	for (let weekday = 1; weekday <= 7; weekday += 1) {
		const weekdayDate = setDate(beginOfMonth, weekday - getDayOfWeek(beginOfMonth));
		const abbr = formatWeekday(locale ?? 'en', weekdayDate);

		weekdays.push(
			<div
				key={weekday}
				className={cn(
					'w-[36px] h-[36px] text-label text-center box-border flex flex-wrap content-center justify-center items-center',
					{
						'--current': isCurrentDayOfWeek(weekdayDate),
						'--weekend': isWeekend(weekdayDate, locale),
					}
				)}
				style={style}
			>
				<abbr aria-label={abbr} title={abbr} className="no-underline text-text-secondary">
					{formatShortWeekday(locale ?? 'en', weekdayDate).replace('.', '')}
				</abbr>
			</div>
		);
	}

	return <Flex count={7}>{weekdays}</Flex>;
}
